<ng-container *ngIf="tagData">
    <div class="px-24 py-16">
        <div class="d-flex flex-row align-items-center justify-content-between">
            <div class="d-flex flex-column" style="width: 474px">
                <div class="d-flex align-items-center mb-8">
                    <div class="mat-body-2 text-black m-0 section-heading">{{ tagData.title }}</div>
                    <span 
                        *ngIf="tagData.tooltip?.length"
                        class="info-tooltip material-icons-outlined ml-4"
                        (mouseover)="!popOverMenuTrigger.menuOpen && popOverMenuTrigger.openMenu()"
                        >info
                        <button #popOverMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="popOverMenu" class="hidden"></button>
                        <mat-menu #popOverMenu="matMenu" class="info-menu-panel px-20 py-12" (click)="$event.stopPropagation()">
                            <div
                                (mouseleave)="popOverMenuTrigger.menuOpen && popOverMenuTrigger.closeMenu()"
                                (click)="$event.stopPropagation()"
                                class="mat-body-2"
                            >
                                {{ tagData.tooltip }}
                            </div>
                        </mat-menu>
                    </span>
                </div>
                <div class="mat-body-2 text-hint m-0">
                    {{ tagData.description }}
                </div>
            </div>

            <button 
                mat-flat-button 
                color="accent" 
                [disabled]="disabled" 
                (click)="openSheet()" 
                class="mx-8 p-0"
            >
                <span 
                    class="d-flex align-items-center px-16" 
                >
                    <mat-icon>add</mat-icon>
                    <span class="px-5">{{ tagData.createBtnLabel }}</span>
                </span>
            </button>
        </div>

        <div class="mt-20" *ngIf="tagData?.availableTags?.length">
            <mat-chip-listbox #chipList class="tag-chip-list">
                <mat-chip-option 
                    *ngFor="let _selectedTag of selectedTags; trackBy: trackByFn" 
                    color="accent"
                    class="bg-accent text-accent"
                    [class.chip-removable]="!disabled"
                    style="font-weight: 500;"
                    [selectable]="false" 
                    [disabled]="disabled"
                >
                    {{ _selectedTag.name }}
                    <button *ngIf="!disabled" class="mat-chip-remove-icon" (click)="removeTag(_selectedTag.id)">
                        <mat-icon class="text-accent" style="font-size: 20px;">cancel</mat-icon>
                    </button>
                </mat-chip-option>
            </mat-chip-listbox>
        </div>
    </div>

    <ng-template #sheetTemp>
        <div *ngIf="tagData?.formData" class="preview-container">
            <span>
                <div class="head-section">
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <div class="mat-body-1 text-black mb-0">{{ tagData.formData.title }}</div>

                        <button mat-icon-button (click)="closeForm(true)">
                            <mat-icon class="text-hint">cancel</mat-icon>
                        </button>
                    </div>

                    <div class="mat-body-2 text-hint mb-8">
                       {{ tagData.formData.description }}
                    </div>
                    <mat-divider></mat-divider>

                    <div class="search-focus-container" [class.search-selected]="searchPanelOpened">
                        <div class="custom-search-bar">
                            <input 
                                type="text" 
                                [placeholder]="'Search or create tag...'" 
                                [(ngModel)]="searchInputValue" 
                                maxlength="50" 
                                (focus)="openSearchPanel()"
                                (ngModelChange)="getValidateTagPattern()"
                            />

                            <mat-icon class="search-info text-hint">search</mat-icon>
                            <button *ngIf="searchPanelOpened" mat-icon-button class="search-cancel-btn" (click)="resetSearch()">
                                <mat-icon class="material-icons-outlined text-hint">close</mat-icon>
                            </button>
                        </div>

                        <mat-card class="search-option-panel mat-elevation-z3" [class.opened]="searchPanelOpened" [class.has-search-text]="searchInputValue.length">
                            <div class="search-panel-inner-action">
                                <button 
                                    *ngIf="!reachedMaxLimit && searchInputValue.length" 
                                    mat-button 
                                    class="px-8"
                                    (click)="createTag()" 
                                    [disabled]="createRequestInProgress || !!searchInputErrors.length"
                                >
                                    <span [class.secondary-text]="!createRequestInProgress && !searchInputErrors.length">Create new tag</span> 
                                    <span> "{{searchInputValue.trim()}}"</span>
                                </button>
                                <div *ngFor="let errorMsg of searchInputErrors" class="mat-body-2 warn-text px-16 pt-8">{{errorMsg}}</div>
                            </div>

                            <div class="mat-body-2 px-16 pt-16 highlighted-text mb-8">Results</div>
                            <div *ngIf="!searchTags?.length" class="mb-16">
                                <mat-divider class="mb-8"></mat-divider>
                                <div class="mat-body-2 pt-12 px-16">{{'No results found for this searched tag'}}</div>
                            </div>
                            <mat-list #autoTagList class="p-0">
                                <ng-container *ngFor="let _tag of searchTags; let i = index; let lastitem = last; trackBy: trackByFn">
                                    <mat-list-item>
                                        <div class="d-flex align-items-center">
                                            <mat-checkbox 
                                                [checked]="_tag.checked" 
                                                (change)="listChange($event.checked, _tag.id)" 
                                                [disabled]="!_tag.checked && reachedMaxLimit"
                                            ></mat-checkbox>
                                            <span style="max-width: 580px;" class="text-truncate pl-16">{{_tag.name}}</span>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider *ngIf="!lastitem"></mat-divider>
                                </ng-container>
                            </mat-list>
                        </mat-card>

                        <div class="tags-checked-list mt-12">
                            <div class="mat-body-2 mb-8">Selected tags (max 5):</div>
    
                            <mat-chip-listbox class="mb-2">
                                <mat-chip-option 
                                    *ngFor="let _tag of checkedTags; let i = index; trackBy: trackByFn" 
                                    [removable]="true" 
                                    (removed)="listChange(false, _tag.id)" 
                                    class="trigger-chip custom-chip-style"
                                >{{ _tag.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            </mat-chip-listbox>
                            
                            <div *ngIf="!checkedTags.length" class="mat-body-2 pt-12 px-16">{{'0 tags selected'}}</div>
                            <div *ngIf="maxLimitErrorFlag" class="mat-body-2 warn-text pt-12">{{'Maximum limit reached. You can add up to 5 tags only. Try removing one before adding a new tag.'}}</div>
                        </div>
                    </div>
                </div>

                <div class="content-section-padding">
                    <div class="content-margins">
                        <div class="tag-check-list mt-12" *ngIf="!searchPanelOpened">
                            <div class="mat-subheading-2 m-0">Available Tags</div>
                            <mat-divider></mat-divider>
                            <mat-list #tagList class="p-0">
                                <ng-container *ngFor="let _tag of tagListValues; let i = index; let lastitem = last; trackBy: trackByFn">
                                    <mat-list-item>
                                        <div class="d-flex align-items-center">
                                            <mat-checkbox 
                                            [checked]="_tag.checked" 
                                            (change)="listChange($event.checked, _tag.id)" 
                                            [disabled]="!_tag.checked && reachedMaxLimit"
                                            ></mat-checkbox>
                                            <span style="max-width: 580px;" class="text-truncate pl-16">{{_tag.name}}</span>
                                        </div>
                                    </mat-list-item>
                                    <mat-divider *ngIf="!lastitem"></mat-divider>
                                </ng-container>
                            </mat-list>
                        
                            <div *ngIf="!tagListValues.length" class="mat-body-2 pt-12 px-16 mb-12">{{'No tags available. Use the above search to create a tag by typing the tag name.'}}</div>
                        </div>
                    </div>
                </div>
            </span>


            <div class="action-section">
                <div class="d-flex align-items-center justify-content-between h-48">
                    <button mat-button class="mx-8" (click)="clearAll()">
                        {{ tagData.formData.buttons[0] }}
                    </button>
                    <span>
                        <button mat-button class="mx-8" (click)="closeForm(true)">
                            {{ tagData.formData.buttons[1] }}
                        </button>
                        <button mat-button color="accent" (click)="closeForm()">
                            {{ tagData.formData.buttons[2] }}
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #contentWithLinkTemp let-contentData="data">
    <mat-card class="notify-warn-card error-warn mat-elevation-z0 mt-16">
        <div class="d-flex align-items-center">
            <mat-icon>error</mat-icon>
            <div class="mat-body-2 m-0">{{ contentData }}</div>
        </div>
    </mat-card>
</ng-template>
